import {
  StatusFilterButtonItem,
  QuickStatusFilterButtons,
} from 'components/common';

import { Submission, SubmissionStatus } from 'interfaces';

interface SubmissionTopToolbarProps {
  submissions: Submission[];
  filterStatus: SubmissionStatus | undefined;
  setFilterStatus: (status: SubmissionStatus | undefined) => void;
}

export const SubmissionTopToolbar: React.FC<SubmissionTopToolbarProps> = ({
  submissions,
  filterStatus,
  setFilterStatus,
}) => {
  const submissionStatuses = Object.values(SubmissionStatus);
  const allKey = 'all';
  type SubmissionStatusFilterKey = SubmissionStatus | typeof allKey;

  const getStatusCount = (status: SubmissionStatus): number => {
    return submissions.filter(
      (submission: Submission) => submission.status === status
    ).length;
  };

  const items: StatusFilterButtonItem<SubmissionStatusFilterKey>[] = [
    {
      key: allKey,
      label: 'All',
      count: submissions.length,
      active: filterStatus === undefined,
      dataTestId: 'filter-all-button',
    },
    ...submissionStatuses.map((status) => ({
      key: status as SubmissionStatusFilterKey,
      label: status,
      count: getStatusCount(status as SubmissionStatus),
      active: filterStatus === status,
      dataTestId: `filter-${status}-button`,
    })),
  ];

  const handleStatusSelect = (key: SubmissionStatusFilterKey) => {
    if (key === allKey) {
      setFilterStatus(undefined);
      return;
    }
    setFilterStatus(key as SubmissionStatus);
  };

  return (
    <QuickStatusFilterButtons
      items={items}
      onSelect={handleStatusSelect}
      topKeys={items.map((item) => item.key)}
    />
  );
};
